import { type MutationHookOptions, useMutation } from "@apollo/client";
import { CreatePromocodeMutation } from "../graphql/mutations";
import type {
  CreatePromocodeMutationType,
  CreatePromocodeMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useCreatePromocodeMutation = (
  options?: MutationHookOptions<
    CreatePromocodeMutationType,
    CreatePromocodeMutationVariablesType
  >
) => {
  return useMutation<
    CreatePromocodeMutationType,
    CreatePromocodeMutationVariablesType
  >(CreatePromocodeMutation, options);
};
